import { useEffect, useState } from 'react'

interface VerificationCountdown {
  seconds: number
  minutes: number
  isCountingDown: boolean
}

export const useVerifyingCountdown = (time: number): VerificationCountdown => {
  const [countDown, setCountDown] = useState(time)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (countDown > 0) {
        setCountDown(countDown - 1000)
      }
    }, 1000)

    if (countDown === 0) {
      clearTimeout(timer)
    }

    return () => {
      clearTimeout(timer)
    }
  }, [countDown])

  useEffect(() => {
    setCountDown(time)
  }, [time])

  if (time === 0) {
    return {
      seconds: 0,
      minutes: 0,
      isCountingDown: false,
    }
  }

  const seconds = Math.floor(countDown / 1000) % 60
  const minutes = Math.floor(countDown / 1000 / 60)
  const isCountingDown = countDown > 0

  return {
    seconds,
    minutes,
    isCountingDown,
  }
}
